import { useEffect, useMemo, useRef, useState } from 'react'
import { container } from 'tsyringe'
import { ModelService } from '../services/ModelService'
import type { ModelLanguageCode, ModelResponse } from '../shared/types/Model'

export function useModels(ready: boolean, language: ModelLanguageCode) {
  const service = useMemo(() => container.resolve(ModelService), [])
  const [models, setModels] = useState<ModelResponse[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)
  const loaded = useRef(false)

  useEffect(() => {
    if (!ready) return
    void language

    if (!loaded.current) {
      loaded.current = true
      setLoading(true)
      setError(null)

      service
        .getModels(language)
        .then((ms) => {
          try {
            setModels(ms)
          } catch (transformError) {
            console.error('Error transforming model data:', transformError)
            throw new Error('Failed to process model data')
          }
        })
        .catch((err) => {
          const errorMessage =
            err instanceof Error
              ? err.message
              : 'Unknown error occurred while loading models'
          setError(errorMessage)
          console.error('Models loading error:', err)
        })
        .finally(() => setLoading(false))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ready, language])

  return { models, loading, error }
}
